<template>
  <div class="teacher">
    <div class="left" v-if="base">
      <div class="left-bg" :style="{ backgroundImage: `url(${backUrl})` }">
        <img class="left-avatar" :src="base.creatorAvatar"/>
      </div>
      <div class="left-teach-info">
        <p class="teach-name">
          {{base.creatorName}}
        </p>
        <p class="teach-subtitle ">
          {{base.identities && formatLen(base.identities.text, 8)}}
        </p>
        <div class="teach-tags">
          <template v-for="(item, index) in base.tags">
            <span  :key="index" v-if="index < 3">
              {{formatLen(item, 10)}}
            </span>
            <span  :key="index" v-if="index > 2 && index < 7">
              {{formatLen(item, 6)}}
            </span>
          </template>
        </div>
        <div class="teach-intro">
          {{formatLen(base.creatorIntroduction, 60)}}
        </div>
        <div class="left-footer">
          查看老师更多动态，请
          <router-link target="_blank" to="/d" class="download-app">下载APP</router-link>
        </div>
      </div>
    </div>
    <div class="right">
      <div :class="fixed ? 'tab fixed' : 'tab'">
        <span :class="{ active: showTabIndex === 0 }" @click="toggle(0)" >教师介绍</span>
        <span :class="{ active: showTabIndex === 1 }" @click="toggle(1)" v-if="count && count > 0">在售课程</span>
      </div>
      <div :class="fixed ? 'intro intro-fixed' : 'intro'" ref="intro">
        <template v-if="contents && contents.length > 0">
          <div v-for="(item, index) of contents" :key="index" class="teach-contents">
            <p class="label">{{item.title}}</p>
            <p class="desc">{{item.content}}</p>
          </div>
        </template>
        <div class="teach-contents">
          <p class="label">教师风采</p>
          <p v-if="base" class="desc" v-html="base.teachingInfo || '暂无'"></p>
        </div>
      </div>
      <div class="course" v-if="count && count > 0">
        <p class="title">在售课程</p>
        <template v-if="initCourseList.length > 1">
          <course-card
            v-for="(item, index) in initCourseList"
            :key="index"
            :data="item"
            :clickId="'1.3.9'"
            :index="index + 1"
            :courseType="item.courseType + 2"
            :termId="item.terms && item.terms[0] && item.terms[0].name"
            :keyName="'xeslog-clickGuessYouLikeCourseCard'"
            :width="'382px'"
            style="padding: 20px 19px 8px;"
          />
        </template>
      </div>
    </div>
    <transition name="fade">
      <div v-if="openToast" class="alert__dialog__toast">该老师不存在</div>
    </transition>
  </div>

</template>

<script>
import { Teacher } from '@/networks/api'
import CourseCard from '@/components/CourseCard'
// import template from '../../../template.vue'
import Vue from 'vue'
export default {
  data() {
    return {
      fixed: false,
      showTabIndex: 0,
      backUrl: '',
      base: '',
      courses: null,
      contents: null,
      grade: null,
      subject: null,
      count: null,
      creatorId: null,
      initCourseList: null,
      openToast: false
    }
  },
  components: {
    CourseCard
  },
  created() {
    const { teacherId } = this.$route.params
    const { switch_grade, switch_subject } = this.$route.query
    this.grade = switch_grade
    this.subject = switch_subject
    this.updateTeacherInfo(teacherId)
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.fixed = (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop) > 157
      if(this.$refs.intro) {
        this.showTabIndex = (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop) < this.$refs.intro.offsetHeight + 210 ? 0 : 1
      }
    })

    const XESLog = new this.$XESLog({
      key: 'teacher-page-pv'
    })
    XESLog.push({ eventname: 'exposure' }, this.$route)
  },
  methods: {
    toggle(index) {
      if (!this.$refs.intro) return
      const offsetHeight = this.$refs.intro.offsetHeight
      window.scrollTo(0, index === 0 ? 180 : offsetHeight + 210)
      this.showTabIndex = index
    },
    async updateTeacherInfo(id) {
      let formdata;
      if(Vue.prototype.$isServer) {
        let FormData = require('form-data');
        formdata = new FormData();
      } else {
        formdata = new FormData();
      }
      formdata.append('teacherId', ~~id)
      const { data = {} } = await Teacher.getTeacherInfo(formdata, {
        headers: {
          'x-grade': this.grade
        }
      })
        .then(response => {
          return response.data
        })
        .catch(response => {
          return {}
        })
      if (Array.isArray(data) && data?.length < 1) {
        this.openToast = true
        setTimeout(() => {
          this.openToast = false
        }, 1500)
        return
      }
      this.backUrl = data?.backUrl || require('./img/left-top-bg.png')
      this.$set(this, 'base', data?.base)
      this.creatorId = data?.base?.creatorId
      this.$set(this, 'contents', data?.contents)
      this.$set(this, 'courses', data?.courses)
      this.$set(this, 'initCourseList', this.dealCourse(data?.courses?.courseList))
      this.count = this.courses?.total
    },
    getContent(content) {
      return content && content.split(/[(\r\n)\r\n]+/)
    },
    dealCourse(courseList) {
      const list = courseList && courseList.map(item => {
        return {
          ...item,
          name: item.courseName,
          syllabusNum: item.syllabusNum.count,
          id: item.courseId,
          isHaveCounselorTeacher: item.class.showCounselorTeacher,
          price: {
            ...item.price,
            origin: item.price.originPrice
          }
        }
      })
      return list
    },
    formatLen(string, len) {
      if (!string) return string
      if (string.length > len) {
        return string.substring(0, len) + '...'
      }
      return string
    }
  }
}
</script>

<style scoped lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// ./src/views/TeacherInfo/index.vue